// Generated file - do not change manually!

/**
 * Different types of TableRow.
 */
export enum TableRowType {
  /**
   * Indicates that the table row is clickable via active feedback when item is pressed.
   */
  Active = 'Active',

  /**
   * Indicates that the table row does not have any active feedback when item is pressed.
   */
  Inactive = 'Inactive'
}
